import React, { useState } from "react";
import CreatableSelect from "react-select/creatable";
import { SwitchComponent } from "@syncfusion/ej2-react-buttons";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { multiSelectStyle } from "../../constant";

const CustomTimePicker = ({ alertConfig, setAlertConfig }) => {
  const handleDaysChange = (e) => {
    setAlertConfig((prevAlertConfig) => ({
      ...prevAlertConfig,
      interval: {
        ...prevAlertConfig.interval,
        days: e.value,
      },
    }));
  };

  const handleHoursChange = (e) => {
    setAlertConfig((prevAlertConfig) => ({
      ...prevAlertConfig,
      interval: {
        ...prevAlertConfig.interval,
        hours: e.value,
      },
    }));
  };

  const handleMinutesChange = (e) => {
    setAlertConfig((prevAlertConfig) => ({
      ...prevAlertConfig,
      interval: {
        ...prevAlertConfig.interval,
        minutes: e.value,
      },
    }));
  };

  return (
    <div className=" flex gap-3 space-y-1 items-center">
      <label htmlFor="days">Days:</label>
      {/* <ComboBox
        className=" w-20"
        style={{ width: 100 }}
        data={[...Array(101).keys()]}
        value={alertConfig.alertData.interval.days}
        onChange={handleDaysChange}
      ></ComboBox> */}
      <NumericTextBox
        style={{ width: 100 }}
        min={0}
        max={101}
        value={alertConfig.interval.days}
        onChange={handleDaysChange}
      />
      <label htmlFor="hours">Hours:</label>
      {/* <ComboBox
        className=""
        style={{ width: 100 }}
        data={[...Array(24).keys()]}
        value={alertConfig.alertData.interval.hours || 0}
        onChange={handleHoursChange}
      ></ComboBox> */}
      <NumericTextBox
        min={0}
        max={24}
        style={{ width: 100 }}
        value={alertConfig.interval.hours}
        onChange={handleHoursChange}
      />
      <label htmlFor="minutes">Minutes:</label>
      {/* <ComboBox
        className=""
        style={{ width: 100 }}
        data={[...Array(60).keys()]}
        value={alertConfig.alertData.interval.minutes}
        onChange={handleMinutesChange}
      ></ComboBox> */}
      <NumericTextBox
        style={{ width: 100 }}
        min={0}
        max={60}
        value={alertConfig.interval.minutes}
        onChange={handleMinutesChange}
      />
    </div>
  );
};

function InactiveAlert({ alertConfig, onClose, onInactiveAlertSave }) {
  const [alertForm, setAlertForm] = useState(alertConfig);
  const [loading, setLoading] = useState(false);

  const handleEmailChange = (event) => {
    setAlertForm((pre) => ({
      ...pre,
      emails: event,
    }));
  };

  const onCheckBoxChange = (e) => {
    setAlertForm((pre) => ({
      ...pre,
      active: e.target.checked,
    }));
  };

  const onSave = async () => {
    setLoading(true);
    await onInactiveAlertSave(alertForm);
    setLoading(false);
    onClose();
  };

  return (
    <div className="relative flex flex-col text-white px-5 space-y-4 py-5 pb-3 bg-neutral-900 w-fit h-fit rounded-md">
      <div className="space-x-2 space-y-2">
        <label>Interval:</label>
        <CustomTimePicker
          setAlertConfig={setAlertForm}
          alertConfig={alertForm}
        />
      </div>
      <div>
        <label>Emails:</label>
        <CreatableSelect
          isMulti
          options={[]}
          name="options"
          {...multiSelectStyle}
          className="text-white bg-zinc-700 focus:ring-0 focus:outline-none rounded-xl w-full h-9"
          value={alertForm.emails}
          onChange={(e) => handleEmailChange(e)}
        />
      </div>

      <div className="flex justify-between items-center py-3 mb-1 text-xs w-full font-medium">
        <div className="space-x-2">
          <label>Alert Active:</label>
          <SwitchComponent
            onLabel="ON"
            offLabel="OFF"
            name="singleSignOn"
            checked={alertForm.active}
            onChange={onCheckBoxChange}
          />
        </div>
        <div className="h-full flex gap-2">
          <button
            type="button"
            className=" bg-white text-black h-8 rounded-4xl text-center w-20"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSave}
            className="px-3 py-1 bg-green-600 text-white disabled:opacity-40 rounded-2xl w-20"
            disabled={
              (alertForm.active &&
                (alertForm.interval.days === null ||
                  alertForm.interval.days === null ||
                  alertForm.interval.days === null)) ||
              loading
            }
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default InactiveAlert;
